import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { RoleEditForm } from "./components/RoleEditForm";

export function EditRolePage() {
  return (
    <Page title="Edit Role">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <RoleEditForm />
      </Container>
    </Page>
  );
}
